import { render, staticRenderFns } from "./exchange3.vue?vue&type=template&id=50729aed&scoped=true&"
import script from "./exchange3.vue?vue&type=script&lang=js&"
export * from "./exchange3.vue?vue&type=script&lang=js&"
import style0 from "./exchange3.vue?vue&type=style&index=0&id=50729aed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50729aed",
  null
  
)

export default component.exports